import type { CreatePickUpDto, GetPickUpDto, PickUpDto, UpdatePickUpDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PickUpService {
  apiName = 'Default';
  

  create = (input: CreatePickUpDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto>({
      method: 'POST',
      url: '/api/app/pick-up',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/pick-up/${id}`,
    },
    { apiName: this.apiName,...config });
  

  generateExcel = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'POST',
      responseType: 'blob',
      url: '/api/app/pick-up/generate-excel',
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto>({
      method: 'GET',
      url: `/api/app/pick-up/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPickUpDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PickUpDto>>({
      method: 'GET',
      url: '/api/app/pick-up',
      params: { keyword: input.keyword, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getPickUps = (sommelierSlug?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto[]>({
      method: 'GET',
      url: '/api/app/pick-up/pick-ups',
      params: { sommelierSlug },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: UpdatePickUpDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto>({
      method: 'PUT',
      url: `/api/app/pick-up/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
